import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SEOHead from '../../components/SEOHead';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Vertiix",
    "description": "Digital Factory per il tuo marketing. Sistema operativo della crescita per aziende che vogliono governare la crescita, non subirla.",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
    "logo": "https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "info@vertiix.ch",
      "contactType": "Customer Service"
    }
  };

  return (
    <div className="bg-white text-gray-900">
      <SEOHead 
        title="Vertiix - Digital Factory per il tuo marketing"
        description="Vertiix è la Digital Factory che costruisce e governa il sistema operativo della tua crescita. Non un fornitore aggiuntivo, ma l'infrastruttura di regia per aziende che vogliono governare la crescita, non subirla."
        keywords="digital factory, sistema operativo crescita, infrastruttura digitale, marketing governabile, crescita aziendale, vertiix"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`}
        ogImage="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png"
        schema={schema}
      />
      
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 py-3 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
              alt="Vertiix" 
              className="h-12 sm:h-16 md:h-20 lg:h-24"
            />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-700' : 'text-gray-600'}`}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6 lg:gap-12">
            <Link to="/" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Home
            </Link>
            <Link to="/problema" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Il Problema
            </Link>
            <Link to="/vertiix" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Cos'è Vertiix
            </Link>
            <Link to="/come-funziona" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Come Funziona
            </Link>
            <Link to="/accesso" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Come Si Accede
            </Link>
            <Link to="/valutazione" className={`px-5 lg:px-6 py-2.5 lg:py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer text-xs`}>
              VALUTAZIONE
            </Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-4 sm:px-6 py-4 space-y-3">
              <Link to="/" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Home
              </Link>
              <Link to="/problema" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Il Problema
              </Link>
              <Link to="/vertiix" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Cos'è Vertiix
              </Link>
              <Link to="/come-funziona" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Funziona
              </Link>
              <Link to="/accesso" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Si Accede
              </Link>
              <Link to="/valutazione" className="block text-center px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer mt-4 text-xs" onClick={() => setMobileMenuOpen(false)}>
                VALUTAZIONE
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center bg-gradient-to-br from-[#f0fdf9] via-white to-[#f0fdf9] overflow-hidden pt-20 sm:pt-24 md:pt-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#14B8A6]/5 via-transparent to-[#14B8A6]/5"></div>
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'url(https://public.readdy.ai/ai/img_res/ec6943652dbb5eb2ccdfa395785824bc.jpg)', backgroundSize: 'cover', backgroundPosition: 'right center' }}></div>
        
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 py-12 sm:py-16 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8">
          <div className="lg:col-span-7">
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-[72px] leading-[1.15] font-semibold mb-6 sm:mb-8 md:mb-12 text-gray-900">
              Il problema non è il marketing.<br/>
              È l'<em className="italic text-[#14B8A6]">assenza di controllo</em>.
            </h1>
            
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 font-light max-w-[520px] mb-8 sm:mb-10 md:mb-16 leading-relaxed">
              La differenza tra fare attività e governare un sistema.
            </p>
            
            <div className="space-y-5 sm:space-y-6 md:space-y-8 max-w-[600px] mb-8 sm:mb-10 md:mb-16">
              <p className="text-sm md:text-base leading-[1.75] text-gray-700">
                Le aziende accumulano fornitori, strumenti, campagne. Ogni elemento funziona in modo isolato. Nessuno coordina. Nessuno governa. Il risultato è frammentazione.
              </p>
              
              <p className="text-sm md:text-base leading-[1.75] text-gray-700">
                Senza una regia centrale, ogni investimento diventa imprevedibile. Le decisioni si prendono senza lettura chiara. La crescita non è scalabile perché non è governabile.
              </p>
              
              <p className="text-sm md:text-base leading-[1.75] text-gray-700">
                Vertiix è la Digital Factory che costruisce e governa il sistema operativo della tua crescita. Non un fornitore aggiuntivo. L'infrastruttura di regia.
              </p>
            </div>
            
            <Link 
              to="/valutazione" 
              className="inline-block px-6 sm:px-8 md:px-12 py-3 md:py-4 bg-[#14B8A6] text-white text-xs tracking-[0.5px] uppercase hover:bg-[#0d9488] transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Richiedi Valutazione Sistema
            </Link>
          </div>
          
          <div className="lg:col-span-5 relative mt-8 lg:mt-0">
            <div className="w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px]">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/6a9e8b06d52d5dd6ac647f768cf4e2d8.png" 
                alt="Sistema Vertiix" 
                className="w-full h-full object-cover opacity-60"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Transition Section */}
      <section className="bg-[#f8faf9] min-h-[85vh] flex items-center py-12 sm:py-16 md:py-0">
        <div className="w-full grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-5 relative px-4 sm:px-6 md:px-12 py-12 md:py-20 flex flex-col justify-center lg:ml-[120px]">
            <div className="text-[60px] sm:text-[80px] md:text-[120px] lg:text-[180px] font-serif opacity-[0.06] absolute top-6 sm:top-8 md:top-12 lg:top-20 left-4 sm:left-6 md:left-12 lg:left-20 leading-none text-[#14B8A6]">01</div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-5 sm:mb-6 md:mb-8 relative z-10 text-gray-900">Il Sistema<br/>Non Esiste</h2>
            <div className="text-sm sm:text-base md:text-lg text-gray-600 max-w-[420px] leading-relaxed relative z-10 space-y-3 sm:space-y-4">
              <p>
                La maggior parte delle aziende non ha un sistema.<br/>
                Ha una somma di attività scollegate che consumano risorse senza generare controllo.
              </p>
              <p>
                Ogni azione può sembrare sensata.<br/>
                Ma senza una regia centrale, l'insieme non costruisce nulla.
              </p>
            </div>
          </div>
          
          <div className="lg:col-span-7 px-4 sm:px-6 md:px-12 py-12 md:py-20 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 md:gap-6">
            <div className="bg-white border border-gray-200 p-5 sm:p-6 md:p-10 hover:border-[#14B8A6] transition-all duration-300">
              <div className="w-6 h-6 mb-4 sm:mb-5 md:mb-6 flex items-center justify-center">
                <i className="ri-links-line text-xl sm:text-2xl text-[#14B8A6]"></i>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-medium mb-2 sm:mb-3 md:mb-4 text-gray-900">Frammentazione Operativa</h3>
              <p className="text-xs sm:text-sm leading-relaxed text-gray-600">
                Ogni reparto, ogni fornitore, ogni strumento opera in autonomia. Nessuna coordinazione. Nessuna regia. Solo attività parallele che non si parlano e non costruiscono valore cumulativo.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-5 sm:p-6 md:p-10 hover:border-[#14B8A6] transition-all duration-300">
              <div className="w-6 h-6 mb-4 sm:mb-5 md:mb-6 flex items-center justify-center">
                <i className="ri-eye-off-line text-xl sm:text-2xl text-[#14B8A6]"></i>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-medium mb-2 sm:mb-3 md:mb-4 text-gray-900">Decisioni al Buio</h3>
              <p className="text-xs sm:text-sm leading-relaxed text-gray-600">
                Senza una lettura chiara del sistema, ogni scelta diventa opinione. Le strategie cambiano in base all'ultimo report disponibile, non a una comprensione reale di ciò che sta funzionando.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-5 sm:p-6 md:p-10 hover:border-[#14B8A6] transition-all duration-300">
              <div className="w-6 h-6 mb-4 sm:mb-5 md:mb-6 flex items-center justify-center">
                <i className="ri-line-chart-line text-xl sm:text-2xl text-[#14B8A6]"></i>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-medium mb-2 sm:mb-3 md:mb-4 text-gray-900">Investimenti Dispersi</h3>
              <p className="text-xs sm:text-sm leading-relaxed text-gray-600">
                Ogni spesa è giustificabile singolarmente. Ma l'insieme non produce alcun sistema. Budget allocati su strumenti e fornitori diversi, senza una visione unificata che trasformi l'investimento in struttura.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 p-5 sm:p-6 md:p-10 hover:border-[#14B8A6] transition-all duration-300">
              <div className="w-6 h-6 mb-4 sm:mb-5 md:mb-6 flex items-center justify-center">
                <i className="ri-forbid-line text-xl sm:text-2xl text-[#14B8A6]"></i>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-medium mb-2 sm:mb-3 md:mb-4 text-gray-900">Crescita Non Scalabile</h3>
              <p className="text-xs sm:text-sm leading-relaxed text-gray-600">
                Senza infrastruttura, ogni tentativo di crescita richiede sforzo lineare. Non c'è leva. Non c'è moltiplicazione. Solo più lavoro per ottenere marginalmente di più.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-white py-12 sm:py-16 md:py-24 lg:py-32 border-t border-gray-200">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 text-center">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-serif font-medium mb-5 sm:mb-6 md:mb-8 text-gray-900">
            La frammentazione non si risolve aggiungendo fornitori.
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 md:mb-12 max-w-[720px] mx-auto leading-relaxed">
            Si risolve costruendo un'infrastruttura di regia che coordina, governa e ottimizza ogni elemento del sistema.
          </p>
          <Link 
            to="/vertiix" 
            className="inline-block px-6 sm:px-8 md:px-12 py-3 md:py-4 bg-[#14B8A6] text-white text-xs tracking-[0.5px] uppercase hover:bg-[#0d9488] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Scopri Cos'è Vertiix
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2332] py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-8 sm:gap-10 md:gap-16 mb-10 sm:mb-12">
            <div className="sm:col-span-2 md:col-span-4">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
                alt="Vertiix" 
                className="h-36 sm:h-40 md:h-48 mb-6 sm:mb-7 md:mb-8"
                style={{ filter: 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.6)) drop-shadow(0 0 30px rgba(255, 255, 255, 0.4)) drop-shadow(0 0 45px rgba(255, 255, 255, 0.3))' }}
              />
              <p className="text-xs sm:text-sm text-gray-400 leading-relaxed">Digital Factory per aziende che vogliono governare la crescita, non subirla.</p>
            </div>
            
            <div className="md:col-span-2">
              <h4 className="text-xs sm:text-sm font-semibold text-white mb-4 sm:mb-5 md:mb-6">Navigazione</h4>
              <nav className="space-y-2 sm:space-y-2.5 md:space-y-3">
                <Link to="/" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Home</Link>
                <Link to="/problema" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Il Problema</Link>
                <Link to="/vertiix" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Cos'è Vertiix</Link>
                <Link to="/come-funziona" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Funziona</Link>
                <Link to="/accesso" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Si Accede</Link>
              </nav>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-xs sm:text-sm font-semibold text-white mb-4 sm:mb-5 md:mb-6">Contatti</h4>
              <p className="text-xs sm:text-sm text-gray-400">info@vertiix.ch</p>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-xs sm:text-sm font-semibold text-white mb-4 sm:mb-5 md:mb-6">Azione</h4>
              <Link to="/valutazione" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors mb-3">Valutazione</Link>
              <Link to="/about-vertiix" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">About Vertiix</Link>
            </div>
          </div>
          
          <div className="pt-6 sm:pt-7 md:pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-[10px] sm:text-xs text-gray-500 text-center md:text-left">
              © 2025 Vertiix. Sistema operativo della crescita.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <a 
                href="https://ti.chregister.ch/cr-portal/auszug/auszug.xhtml?uid=CHE-410.417.125" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                CHE-410.417.125
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors">
                Powered by vertiix
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}